import { render, staticRenderFns } from "./OffsetView.vue?vue&type=template&id=cb2e1080"
import script from "./OffsetView.vue?vue&type=script&lang=js"
export * from "./OffsetView.vue?vue&type=script&lang=js"
import style0 from "./OffsetView.vue?vue&type=style&index=0&id=cb2e1080&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports